import { useEffect, useState } from 'react';

import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { useAppDispatch,useAppSelector } from 'app/hooks';
import { fetchClaimDataTypes } from 'common/services/api/ClaimDataTypes/ClaimDataTypes.thunks';

import { selectClaimDataTypes } from '../claimDataTypes/claimDataTypesSlice';

interface IClaimDataTypesDropDownProps {
    inputRef?: React.Ref<HTMLInputElement | undefined>,
    onChange?: (newValue: string) => void
    defaultTypeName: string;
    disabled?: boolean;
}

export function ClaimDataTypesDropDown(props:Readonly<IClaimDataTypesDropDownProps>) {
    const claimDataTypes = useAppSelector(selectClaimDataTypes);
    const dispatch = useAppDispatch();
    const [currentValue, setCurrentValue] = useState<string>('none');
    const { inputRef, onChange, defaultTypeName, disabled } = props;

    useEffect(() => {
        if (claimDataTypes?.length) {
            return;
        }
        dispatch(fetchClaimDataTypes()).catch(console.error);
    }, []);

    if (claimDataTypes?.length) {
        if(currentValue === 'none' && defaultTypeName) {
            const defaultTypeId = claimDataTypes?.find(x => x.name === defaultTypeName)?.id;
            if(defaultTypeId) {
                setCurrentValue(defaultTypeId);
                onChange?.(defaultTypeId);
            }
        }
    }

    const handleChange = (evt: SelectChangeEvent) => {
        setCurrentValue(evt.target.value);
        onChange?.(evt.target.value);
    };

    return <FormControl>
        <InputLabel id="idp-label">Claim Data Type</InputLabel>
        {<Select
            disabled={disabled}
            labelId="idp-label"
            inputRef={inputRef}
            onChange={handleChange}
            label="Claim Data Type"
            value={currentValue}
            sx={{ color: 'text.secondary' }}>
            <MenuItem value="none" style={{ display: 'none' }} disabled>
                Select Claim Data Type
            </MenuItem>
            { claimDataTypes.map(claim =>
                <MenuItem key={claim.id} value={claim.id}>{claim.name}</MenuItem>) }
        </Select>}
    </FormControl>;
}
